/* ==========================================================================
   RŌZ — "Is this right for my hair?" hair-fit module
   --------------------------------------------------------------------------
   Reads the payload printed by sections/roz-hair-fit.liquid, inserts the
   trigger into the gallery, and appends its panel to <body>.

   Touches nothing else on the page. Every class it writes is prefixed rhf-.
   ========================================================================== */
(function () {
  'use strict';

  var node = document.getElementById('rhf-data');
  if (!node) return;

  var D;
  try { D = JSON.parse(node.textContent); } catch (e) { console.warn('[rhf] bad payload', e); return; }
  if (!D.answers || !D.answers.length) return;

  var STORE_KEY = 'rhf.pick';

  /* ---------- analytics ----------
     Events are named hair_fit_* with hf_* parameters. They go to window.gtag when the
     page has it (Shopify's Google channel installs it, and gtag applies consent mode
     itself), otherwise to dataLayer for GTM. To watch them live and see them in GA4
     DebugView, run localStorage.setItem('rhf.debug', '1') in the browser console. */
  function track(name, params) {
    var p = { hf_product: D.product.title };
    Object.keys(params || {}).forEach(function (k) { p[k] = params[k]; });
    try {
      if (localStorage.getItem('rhf.debug')) { p.debug_mode = true; console.log('[rhf] ' + name, p); }
    } catch (e) { /* storage blocked */ }
    try {
      if (typeof window.gtag === 'function') {
        if (D.ga4) p.send_to = D.ga4;
        window.gtag('event', name, p);
      } else if (window.dataLayer) {
        p.event = name;
        window.dataLayer.push(p);
      }
    } catch (e) { /* analytics must never break the module */ }
  }

  /* answers indexed by hair type — one entry can cover several types; first entry wins */
  var BY_TYPE = {};
  D.answers.forEach(function (a) {
    (a.hairTypes || []).forEach(function (t) {
      if (!t) return;
      if (BY_TYPE[t]) { console.warn('[rhf] hair type "' + t + '" is on more than one entry; using the first'); return; }
      BY_TYPE[t] = a;
    });
  });

  var state = { picks: [], step: 'picker', open: false };

  if (D.persist) {
    try {
      var saved = JSON.parse(localStorage.getItem(STORE_KEY) || '[]');
      if (Array.isArray(saved)) {
        state.picks = saved.filter(offered).slice(0, 2);   /* offered() is hoisted */
      }
    } catch (e) { /* private mode, or cleared — start empty */ }
  }

  /* ---------- tiny DOM helper ---------- */
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v === null || v === undefined || v === false) return;
      if (k === 'cls') n.className = v;
      else if (k === 'text') n.textContent = v;
      else if (k === 'html') n.innerHTML = v;
      else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), v);
      else n.setAttribute(k, v === true ? '' : v);
    });
    (kids || []).forEach(function (c) {
      if (c === null || c === undefined || c === false) return;
      n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return n;
  }

  /* ---------- picks ---------- */
  function groupOf(id) { return D.groups.density.indexOf(id) > -1 ? 'density' : 'texture'; }
  function pickIn(group) {
    for (var i = 0; i < state.picks.length; i++) if (groupOf(state.picks[i]) === group) return state.picks[i];
    return null;
  }
  function density() { return pickIn('density'); }
  function texture() { return pickIn('texture'); }
  function hasBoth() { return !!density() && !!texture(); }

  /* the density pick carries the answer copy; texture only selects the media */
  function answer() {
    return BY_TYPE[density()] || BY_TYPE[texture()] || D.answers[0];
  }

  function picksNoun() {
    var d = density(), t = texture(), parts = [];
    if (d) parts.push(D.labels[d].label.toLowerCase());
    if (t) parts.push(D.labels[t].label.toLowerCase());
    return parts.length ? parts.join(', ') + ' hair' : 'your hair';
  }

  function togglePick(id) {
    var g = groupOf(id), was = state.picks.indexOf(id) > -1;
    state.picks = state.picks.filter(function (o) { return groupOf(o) !== g; });
    if (!was) state.picks.push(id);
    if (D.persist) {
      try { localStorage.setItem(STORE_KEY, JSON.stringify(state.picks)); } catch (e) { /* ignore */ }
    }
    syncCart();
    track('hair_fit_select', {
      hf_group: g, hf_hair_type: id, hf_action: was ? 'deselect' : 'select', hf_picks: picksKey()
    });
    if (hasBoth()) {
      state.step = 'answer';   /* the second pick lands on the answer */
      trackAnswerView('pick');
    }
    render();
  }

  function picksKey() { return [density(), texture()].filter(Boolean).join('+'); }

  /* ---------- cart attributes ----------
     The latest picks ride on the cart as hidden attributes (leading underscore =
     not shown to the shopper), so Shopify copies them onto the order at checkout.
     An empty value removes the attribute when a pick is cleared. */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CART_ATTRS = { density: '_hair_density', texture: '_hair_type' };
  function cartAttrs() {
    var d = density(), t = texture(), out = {};
    out[CART_ATTRS.density] = d ? D.labels[d].label : '';
    out[CART_ATTRS.texture] = t ? D.labels[t].label : '';
    return out;
  }
  function postAttrs(attrs) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }
  /* writes run one at a time and read the picks when they run, so quick taps
     can't land out of order and the last write is always the latest pick.
     Failures are swallowed: checkout must never depend on this. */
  var cartQueue = Promise.resolve();
  function queueCart(job) {
    cartQueue = cartQueue.then(job).catch(function () { /* ignore */ });
    return cartQueue;
  }
  function syncCart() {
    queueCart(function () { return postAttrs(cartAttrs()); });
  }
  /* on load: re-apply saved picks to a cart that lost them (new cart after an order),
     without a write when the cart already matches */
  function resyncCart() {
    if (!density() && !texture()) return;
    queueCart(function () {
      return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var want = cartAttrs(), have = cart.attributes || {};
          var same = Object.keys(want).every(function (k) { return (have[k] || '') === want[k]; });
          if (!same) return postAttrs(want);
        });
    });
  }

  /* hf_via: 'pick' = shopper just completed the two picks, 'reopen' = viewing a saved answer */
  function trackAnswerView(via) {
    var a = answer();
    track('hair_fit_answer_view', {
      hf_via: via,
      hf_picks: picksKey(),
      hf_density: density(),
      hf_texture: texture(),
      hf_entry_types: (a.hairTypes || []).join('+'),
      hf_has_video: videoFor(a) ? 'yes' : 'no',
      hf_has_before_after: beforeAfterFor(a) ? 'yes' : 'no'
    });
  }

  /* ---------- media, with the product-level fallbacks ---------- */
  function beforeAfterFor(a) {
    if (a.beforeAfter && a.beforeAfter.length === 2) return a.beforeAfter;
    var fb = D.fallback && D.fallback.beforeAfter;
    return (fb && fb.length === 2) ? fb : null;
  }
  function videoFor(a) {
    if (a.review && a.review.video) return a.review.video;
    return (D.fallback && D.fallback.video) || null;
  }
  function posterFor(a) {
    if (a.review && a.review.video && a.review.poster) return a.review.poster;
    if (D.fallback && D.fallback.video && !(a.review && a.review.video)) return D.fallback.poster || null;
    return null;
  }

  /* ---------- before / after wipe ---------- */
  function baSlider(pair) {
    var wrap = el('div', { cls: 'rhf-ba', style: '--rhf-pos:50%', role: 'group', 'aria-label': 'Before and after' }, [
      el('img', { cls: 'rhf-after', src: pair[1], alt: 'After', loading: 'lazy' }),
      el('img', { cls: 'rhf-before', src: pair[0], alt: 'Before', loading: 'lazy' }),
      el('span', { cls: 'rhf-lbl rhf-lb', text: 'Before' }),
      el('span', { cls: 'rhf-lbl rhf-la', text: 'After' }),
      el('span', { cls: 'rhf-line' })
    ]);
    var knob = el('button', {
      cls: 'rhf-knob', type: 'button', 'aria-label': 'Drag to compare', html: '&#9666;&#9656;'
    });
    wrap.appendChild(knob);

    function setPos(clientX) {
      var r = wrap.getBoundingClientRect();
      var pct = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
      wrap.style.setProperty('--rhf-pos', pct + '%');
    }
    var dragging = false;
    wrap.addEventListener('pointerdown', function (e) { dragging = true; wrap.setPointerCapture(e.pointerId); setPos(e.clientX); });
    wrap.addEventListener('pointermove', function (e) { if (dragging) setPos(e.clientX); });
    wrap.addEventListener('pointerup', function () { dragging = false; });
    wrap.addEventListener('pointercancel', function () { dragging = false; });
    knob.addEventListener('keydown', function (e) {
      var cur = parseFloat(wrap.style.getPropertyValue('--rhf-pos')) || 50;
      if (e.key === 'ArrowLeft') { wrap.style.setProperty('--rhf-pos', Math.max(0, cur - 4) + '%'); e.preventDefault(); }
      if (e.key === 'ArrowRight') { wrap.style.setProperty('--rhf-pos', Math.min(100, cur + 4) + '%'); e.preventDefault(); }
    });
    return wrap;
  }

  /* ---------- panel content ---------- */
  /* The two rows are taxonomy, not content. A density card needs its own entry
     because the density pick carries the answer copy; a texture card is always
     offered because texture only selects the media and the attribution. If no
     density entry exists at all, every density is offered and the answer falls
     back to the texture entry. */
  function offered(id) {
    if (groupOf(id) === 'texture') return true;
    if (BY_TYPE[id]) return true;
    return !D.groups.density.some(function (d) { return BY_TYPE[d]; });
  }

  function pickerKids() {
    function row(group, label) {
      return el('div', { cls: 'rhf-group', 'data-rhf-group': group }, [
        el('div', { cls: 'rhf-glabel', text: label }),
        el('div', { cls: 'rhf-row' }, D.groups[group].map(function (id) {
          var known = offered(id);
          var on = state.picks.indexOf(id) > -1;
          return el('button', {
            type: 'button',
            cls: 'rhf-card',
            'aria-pressed': on ? 'true' : 'false',
            disabled: !known,
            title: known ? null : 'No answer written for this hair type yet',
            onclick: known ? function () { togglePick(id); } : null
          }, [
            el('span', { cls: 'rhf-n', text: D.labels[id].label }),
            el('span', { cls: 'rhf-b', text: D.labels[id].blurb })
          ]);
        }))
      ]);
    }
    return [
      el('p', { cls: 'rhf-sub', text: D.prompt.sub }),
      row('density', D.prompt.groupDensity),
      row('texture', D.prompt.groupTexture),
      D.prompt.quizUrl ? el('div', { cls: 'rhf-quiz' }, [
        D.prompt.quizLine + ' ',
        el('a', { href: D.prompt.quizUrl, target: '_blank', rel: 'noopener', text: D.prompt.quizCta })
      ]) : null
    ];
  }

  function answerKids() {
    var a = answer(), kids = [];
    kids.push(el('p', { cls: 'rhf-eyebrow', text: 'For ' + picksNoun() }));
    kids.push(el('h3', { cls: 'rhf-h', text: a.headline }));
    if (a.blurb) kids.push(el('p', { cls: 'rhf-blurb', text: a.blurb }));

    if (a.tip) kids.push(el('div', { cls: 'rhf-tip' }, [
      el('span', {
        html: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true">'
            + '<path d="M12 3v3M12 18v3M3 12h3M18 12h3M6 6l2 2M16 16l2 2M18 6l-2 2M8 16l-2 2"/></svg>'
      }),
      el('div', {}, [
        el('div', { cls: 'rhf-l', text: D.prompt.tipLabel }),
        el('p', { text: a.tip })
      ])
    ]));

    var pair = beforeAfterFor(a);
    if (pair) kids.push(baSlider(pair));

    var vid = videoFor(a), r = a.review || {};
    if (r.quote || vid) {
      var med = null;
      if (vid) {
        var v = el('video', {
          src: vid, poster: posterFor(a), playsinline: true, preload: 'auto',
          autoplay: true, muted: true, loop: true, controls: false
        });
        v.muted = true;   /* the attribute alone can miss on some browsers when inserted via JS */
        var unmute = el('button', { cls: 'rhf-play', type: 'button', 'aria-label': 'Unmute the review' }, [
          el('span', { html: '&#128263;' })
        ]);
        med = el('div', { cls: 'rhf-med' }, [v, unmute]);
        unmute.addEventListener('click', function () {
          track('hair_fit_video_unmute', { hf_picks: picksKey() });
          v.muted = false;
          v.controls = true;
          unmute.remove();
        });
        v.addEventListener('error', function () { v.remove(); });
        var tryPlay = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
        tryPlay();
        v.addEventListener('loadeddata', tryPlay, { once: true });
      }
      kids.push(el('div', { cls: 'rhf-review' }, [
        D.prompt.reviewLabel ? el('div', { cls: 'rhf-rlabel', html: D.prompt.reviewLabel }) : null,
        med,
        r.quote ? el('q', { text: r.quote }) : null,
        (r.name || r.descriptor || r.handle) ? el('div', { cls: 'rhf-who' }, [
          r.name ? el('b', { text: r.name }) : null,
          r.descriptor ? el('span', { text: r.descriptor }) : null,
          r.handle ? (r.handleUrl
            ? el('a', { href: r.handleUrl, target: '_blank', rel: 'noopener', text: r.handle })
            : el('span', { text: r.handle })
          ) : null
        ]) : null
      ]));
    }

    if (a.ourTake) kids.push(el('div', { cls: 'rhf-verdict' }, [
      el('div', { cls: 'rhf-l', text: D.prompt.verdictLabel }),
      el('p', { text: a.ourTake })
    ]));


    return kids;
  }

  /* ---------- the panel ---------- */
  var scrim = el('div', { cls: 'rhf-scrim', 'data-open': 'false', onclick: function () { dismiss('scrim'); } });
  var panel = el('div', {
    cls: 'rhf-panel', role: 'dialog', 'aria-modal': 'true', 'aria-label': D.prompt.primary,
    'data-open': 'false', 'data-step': 'picker',
    style: '--rhf-panel-w:' + (D.panelWidth || 464) + 'px'
  });
  document.body.appendChild(scrim);
  document.body.appendChild(panel);

  function paintPanel() {
    var isPicker = state.step === 'picker';
    panel.setAttribute('data-step', isPicker ? 'picker' : 'answer');
    panel.innerHTML = '';

    panel.appendChild(el('div', { cls: 'rhf-head' }, [
      isPicker ? null : el('button', {
        type: 'button', 'aria-label': 'Back to hair type', html: '&larr;',
        onclick: function () { changeHairType('back_arrow'); }
      }),
      isPicker ? el('h2', { text: 'What is your hair like?' })
               : el('span', { cls: 'rhf-ttl', text: D.prompt.primary.toUpperCase() }),
      el('button', { type: 'button', 'aria-label': 'Close', html: '&#10005;', onclick: function () { dismiss('x'); } })
    ]));

    panel.appendChild(el('div', { cls: 'rhf-body' }, isPicker ? pickerKids() : answerKids()));

    if (!isPicker) {
      panel.appendChild(el('div', { cls: 'rhf-foot' }, [
        D.showAtc ? el('button', {
          cls: 'rhf-atc', type: 'button', text: 'Add to cart | ' + D.product.price,
          onclick: addToCart
        }) : null,
        el('div', { cls: 'rhf-lks' }, [
          el('button', { type: 'button', text: 'Change hair type', onclick: function () { changeHairType('link'); } }),
          el('button', { type: 'button', text: 'Back to product', onclick: function () { dismiss('back_to_product'); } })
        ])
      ]));
    }
  }

  /* The panel's Add to cart must go through the theme's own form so the cart
     drawer, subscription selection and analytics all behave normally. */
  function productForm() {
    /* The PDP has several /cart/add forms (bundle upsell, routine steps). Take the
       product's own — never "the first one on the page". */
    var f = document.querySelector('form[id^="ProductForm-"][action*="/cart/add"]');
    if (f) return f;
    var all = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < all.length; i++) {
      var idInput = all[i].querySelector('input[name="id"]');
      if (idInput && String(idInput.value) === String(D.product.variantId)) return all[i];
    }
    return null;
  }

  function addToCart() {
    var form = productForm();
    var idInput = form && form.querySelector('input[name="id"]');
    track('hair_fit_add_to_cart', {
      hf_picks: picksKey(),
      hf_entry_types: (answer().hairTypes || []).join('+'),
      hf_in_form: form ? 'yes' : 'no',
      items: [{ item_id: String(idInput ? idInput.value : D.product.variantId), item_name: D.product.title, quantity: 1 }]
    });
    if (form) {
      close();
      /* let a pending attribute write land first, but never hold the add for more than 1.5s */
      var submitted = false;
      var submit = function () {
        if (submitted) return;
        submitted = true;
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      };
      cartQueue.then(submit);
      setTimeout(submit, 1500);
      return;
    }
    window.location.href = D.product.url;
  }

  var lastTrigger = null;
  function open(step, source) {
    state.step = step || (hasBoth() ? 'answer' : 'picker');
    state.open = true;
    track('hair_fit_open', { hf_source: source || 'trigger', hf_step: state.step, hf_picks: picksKey() });
    if (state.step === 'answer') trackAnswerView('reopen');
    render();
    var first = panel.querySelector('button, a, video');
    if (first) first.focus();
  }
  function close() {
    state.open = false;
    render();
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  }
  /* closing without converting — hf_via says how, hf_step where they gave up */
  function dismiss(via) {
    track('hair_fit_close', { hf_via: via, hf_step: state.step, hf_picks: picksKey() });
    close();
  }
  function changeHairType(via) {
    track('hair_fit_change', { hf_via: via, hf_picks: picksKey() });
    state.step = 'picker';
    render();
  }

  /* outbound links inside the panel: the reviewer's handle, the hair quiz */
  panel.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (a) track('hair_fit_link_click', { hf_link_text: (a.textContent || '').trim().slice(0, 60), hf_link_url: (a.href || '').slice(0, 100) });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) dismiss('escape'); });

  /* ---------- the trigger, inserted into the gallery ---------- */
  var anchor = null, trigger = null, answeredRow = null;

  function ensureAnchor() {
    if (anchor && document.contains(anchor)) return anchor;
    anchor = D.anchor ? document.querySelector(D.anchor) : null;
    if (!anchor) { console.warn('[rhf] anchor not found:', D.anchor); return null; }
    anchor.classList.add('rhf-anchored');
    return anchor;
  }

  function paintTrigger() {
    var answered = D.persist && state.picks.length > 0;

    /* the underlined line over the gallery — stays visible even once answered,
       so it remains a findable way back into the picker; the answered row
       (below) is the separate "see what I got" affordance */
    var existing = document.querySelector('[data-rhf-trigger]');
    if (existing) {
      trigger = existing;                     /* the optional snippet is in use */
    } else {
      var host = ensureAnchor();
      if (host && (!trigger || !document.contains(trigger))) {
        trigger = el('button', { cls: 'rhf-trigger', type: 'button', 'data-rhf-trigger': true, 'aria-haspopup': 'dialog' }, [
          el('span', { text: D.prompt.primary }),
          el('span', { 'aria-hidden': 'true', text: ' →' })
        ]);
        host.appendChild(trigger);
      }
    }
    if (trigger) {
      trigger.hidden = false;
      if (!trigger.dataset.rhfBound) {
        trigger.dataset.rhfBound = '1';
        trigger.addEventListener('click', function () { lastTrigger = trigger; open('picker', 'trigger'); });
      }
    }

    /* the answered row — inserted right after the anchor (a sibling, not nested inside it) */
    if (answered) {
      var explicitHost = D.answeredAnchor ? document.querySelector(D.answeredAnchor) : null;
      var rowHost = explicitHost || ensureAnchor();
      if (rowHost && (!answeredRow || !document.contains(answeredRow))) {
        answeredRow = el('button', { cls: 'rhf-answered', type: 'button' });
        if (explicitHost) {
          explicitHost.insertAdjacentElement('afterend', answeredRow);
        } else {
          rowHost.appendChild(answeredRow);
        }
        answeredRow.addEventListener('click', function () { lastTrigger = answeredRow; open('answer', 'answered_row'); });
      }
      if (answeredRow) {
        answeredRow.innerHTML = '';
        answeredRow.appendChild(el('span', {}, [
          el('span', { cls: 'rhf-a-e', text: D.prompt.answeredLabel + ' ' + picksNoun() }),
          el('span', { cls: 'rhf-a-v', text: answer().headline })
        ]));
        answeredRow.appendChild(el('span', { cls: 'rhf-a-c', text: 'Change' }));
      }
    } else if (answeredRow) {
      answeredRow.remove();
      answeredRow = null;
    }
  }

  function render() {
    paintTrigger();
    paintPanel();
    scrim.setAttribute('data-open', state.open ? 'true' : 'false');
    panel.setAttribute('data-open', state.open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', state.open ? 'false' : 'true');
  }

  /* Some themes rebuild the gallery on variant change, which wipes an inserted
     node. Re-place the trigger if that happens; never re-render the gallery. */
  function watchAnchor() {
    var host = ensureAnchor();
    if (!host || !host.parentNode) return;
    new MutationObserver(function () {
      if (!trigger || !document.contains(trigger)) { trigger = null; paintTrigger(); }
    }).observe(host.parentNode, { childList: true, subtree: true });
  }

  function start() { render(); watchAnchor(); resyncCart(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
